/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
function is_touch_device() {
  return "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

function is_mobile_layout() {
  return window.innerWidth < 1024;
}

if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

/*============================================================================
API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var $body = $(document.body),
    params = {
      type: "POST",
      url: ROUTES.cart.update + ".js",
      data: "note=" + attributeToString(note),
      dataType: "json",
      beforeSend: function () {
        $body.trigger("beforeUpdateCartNote.ajaxCart", note);
      },
      success: function (cart) {
        if (typeof callback === "function") {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger("afterUpdateCartNote.ajaxCart", [note, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger("errorUpdateCartNote.ajaxCart", [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function (jqxhr, text) {
        $body.trigger("completeUpdateCartNote.ajaxCart", [this, jqxhr, text]);
      },
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (!!data.message) {
    alert(data.message + "(" + data.status + "): " + data.description);
  }
};

/*============================================================================
POST to cart/add.js returns the JSON of the cart
  - Allow use of form element instead of just id
  - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: "POST",
      url: ROUTES.cart.add + ".js",
      data: jQuery(form).serialize(),
      dataType: "json",
      beforeSend: function (jqxhr, settings) {
        $body.trigger("beforeAddItem.ajaxCart", form);
      },
      success: function (line_item) {
        if (typeof callback === "function") {
          callback(line_item, form);
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger("afterAddItem.ajaxCart", [line_item, form]);
      },
      error: function (XMLHttpRequest, textStatus) {
        if (typeof errorCallback === "function") {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger("errorAddItem.ajaxCart", [XMLHttpRequest, textStatus]);
      },
      complete: function (jqxhr, text) {
        $body.trigger("completeAddItem.ajaxCart", [this, jqxhr, text]);
      },
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  $(document.body).trigger("beforeGetCart.ajaxCart");
  jQuery.getJSON(ROUTES.cart.page + ".js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger("afterGetCart.ajaxCart", cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: "POST",
      url: ROUTES.cart.change + ".js",
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      beforeSend: function () {
        $body.trigger("beforeChangeItem.ajaxCart", [line, quantity]);
      },
      success: function (cart) {
        if (typeof callback === "function") {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger("afterChangeItem.ajaxCart", [line, quantity, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger("errorChangeItem.ajaxCart", [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function (jqxhr, text) {
        $body.trigger("completeChangeItem.ajaxCart", [this, jqxhr, text]);
      },
    };
  jQuery.ajax(params);
};

ShopifyAPI.changeRemoveItem = function (line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: "POST",
      url: ROUTES.cart.change + ".js",
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      beforeSend: function () {
        $body.trigger("beforeChangeItem.ajaxCart", [line, quantity]);
      },
      success: function (cart) {
        if (typeof callback === "function") {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger("afterChangeItem.ajaxCart", [line, quantity, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger("errorChangeItem.ajaxCart", [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function (jqxhr, text) {
        $body.trigger("completeChangeItem.ajaxCart", [this, jqxhr, text]);
      },
    };
  jQuery.ajax(params);
};
/*============================================================================
Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  "use strict";

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCountAjaxHeader, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, updateDeliveryThreshold, handleCheckoutButton, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
  Initialise the plugin and define global options
==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector: `form[action^="${ROUTES.cart.add}"]`,
      cartContainer: "#CartContainer",
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCountAjaxHeader: null,
      cartCostSelector: null,
      moneyFormat: "$",
      disableAjaxCart: false,
      enableQtySelectors: true,
      standardThreshold: 7500,
      expressThreshold: 10000,
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCountAjaxHeader = $(settings.cartCountAjaxHeader);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass("drawer--is-loading");
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $("#basketToggle").removeClass("empty");
      $cartCountSelector.html(cart.item_count).removeClass("hidden-count");

      if (cart.item_count === 0) {
        $("#basketToggle").addClass("empty");
        $cartCountSelector.addClass("hidden-count");
      }
    }
    if ($cartCountAjaxHeader) {
      $cartCountAjaxHeader.html(cart.item_count);
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };
  formOverride = function () {
    $formContainer.on("submit", function (evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass("is-added").addClass("is-adding");

      // Remove any previous quantity errors
      $(".qty-error").remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);

      // Show header on mobile so cart drawer isn't cut off
      if (is_mobile_layout) {
        document.body.classList.remove("scroll");
      }
    });
  };

  handleCheckoutButton = function () {
    const cartInner = document.querySelector(".cart.ajaxcart");
    const checkoutButtons = document.querySelector(".ajaxcart__footer .inner");

    function isInViewport(el) {
      const cartInner = document.querySelector(".cart.ajaxcart");
      const checkoutButtons = document.querySelector(".ajaxcart__footer .inner");
      const stickyCheckoutButton = document.querySelector(".ajaxcart__footer-button");
      const rect = el.getBoundingClientRect();

      if (cartInner && checkoutButtons) {
        if (rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= -50) {
          stickyCheckoutButton.classList.add("hidden");
        } else {
          stickyCheckoutButton.classList.remove("hidden");
        }
      }
    }

      cartInner.addEventListener(
        "scroll",
        () => {
          isInViewport(checkoutButtons);
        },
        {
          passive: true,
        }
      );

      window.addEventListener(
        "resize",
        () => {
            isInViewport(checkoutButtons);
        },
        {
          passive: true,
        }
      );

      isInViewport(checkoutButtons);

  };

  updateDeliveryThreshold = function (cart) {
    const deliveryThresholdContainer = document.querySelector(".delivery-threshold"),
      standardThreshold = settings.standardThreshold,
      expressThreshold = settings.expressThreshold,
      deliveryText = document.querySelector(".delivery-threshold-text"),
      deliveryMessage = document.querySelector(".delivery-threshold-message"),
      rewardMessage = document.querySelector(".delivery-reward-message"),
      deliveryProgressBar = document.querySelector(".delivery-threshold-percentage-bar"),
      deliveryProgressBarPercent = (cart.total_price / expressThreshold) * 100;

    if (deliveryThresholdContainer) {
      deliveryProgressBar.style.setProperty("--percentage", `${deliveryProgressBarPercent}%`);

      if (cart.total_price == 0) {
        deliveryThresholdContainer.classList.add("hidden");
        deliveryThresholdContainer.classList.remove("express-delivery", "standard-delivery");
      } else if (cart.total_price < standardThreshold) {
        deliveryThresholdContainer.classList.remove("hidden", "success", "standard-delivery", "express-delivery");
        const difference = standardThreshold - cart.total_price;
        deliveryMessage.innerHTML = `You're <b>${Shopify.formatMoney(difference, settings.moneyFormat)}</b> away from Free Standard UK Delivery`;
        rewardMessage.innerText = "";
      } else if (cart.total_price >= standardThreshold && cart.total_price < expressThreshold) {
        deliveryThresholdContainer.classList.remove("hidden", "express-delivery");
        deliveryThresholdContainer.classList.add("standard-delivery");
        const difference = expressThreshold - cart.total_price;
        deliveryMessage.innerHTML = `You're <b>${Shopify.formatMoney(difference, settings.moneyFormat)}</b> away from Free Express UK Delivery`;
        rewardMessage.innerHTML = `Free Standard UK Delivery`;
      } else if (cart.total_price >= expressThreshold) {
        deliveryThresholdContainer.classList.remove("hidden");
        deliveryThresholdContainer.classList.add("express-delivery");
        deliveryMessage.innerHTML = "";
        rewardMessage.innerText = "Free Express UK Delivery!";
      }
    }
  };

  itemAddedCallback = function (product) {
    $addToCart
      .removeClass("is-adding")
      .addClass("is-added")
      .delay(4000)
      .queue(function (rvt) {
        $addToCart.removeClass("is-added");
        rvt();
      });

    document.getElementById("basketToggle").click();

    $("#GoToCheckout").css("display", "block");
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    $addToCart.removeClass("is-adding is-added");

    if (!!data.message) {
      if (data.status == 422) {
        $(".product-switcher").after('<div class="errors qty-error button-text">' + data.description + "</div>");
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.removeClass("empty").empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.addClass("empty");
      var data = {},
        source = $("#CartEmptyTemplate").html(),
        template = Handlebars.compile(source);

      $cartContainer.append(template(data));
      cartCallback(cart);
      if (jQuery(".ajaxcart__feature-products .product-grid.owl-carousel").length) {
        jQuery(".ajaxcart__feature-products .product-grid.owl-carousel").owlCarousel({
          items: 1,
          margin: 10,
          loop: false,
          nav: false,
          dots: false,
          autoplay: false,
          autoplaySpeed: 1000,
          autoWidth: false,
          mouseDrag: true,
          touchDrag: true,
          onInitialized: function (event) {
            jQuery(".juno-quick-add .product-option-size li").click(function (e) {
              e.preventDefault();
              if (jQuery(this).hasClass("out-of-stock")) {
                return;
              } else {
                console.log("data = ", jQuery(this).attr("data-link"));
                return;
                window.location = jQuery(this).attr("data-link");
              }
            });

            var el = jQuery(event.currentTarget);
            el.append('<div class="scrollbar"><div class="bar"></div></div>');
            el.find(".scrollbar .bar").draggable({
              axis: "x",
              containment: "parent",
              drag: function (e, ui) {
                var stage = el.children(".owl-stage-outer"),
                  stage = stage.children(".owl-stage"),
                  scrollbar = el.find(".scrollbar"),
                  bar = el.find(".scrollbar .bar"),
                  left = ui.position.left,
                  scrollPos = left / (scrollbar.width() - bar.width()),
                  margin = stage.children(".owl-item").css("marginRight").replace("px", ""),
                  overWidth = stage.width() - el.width() - margin,
                  stageScrollPos = 0;
                stageScrollPos = overWidth * scrollPos;
                stage.css({
                  transform: "translate3d(-" + stageScrollPos + "px, 0px, 0px)",
                  transition: "0s",
                });
              },
            });
          },
          onDragged: function (event) {
            var el = jQuery(event.currentTarget),
              stage = el.find(".owl-stage"),
              scrollbar = el.find(".scrollbar"),
              bar = el.find(".scrollbar .bar"),
              margin = el.find(".owl-item").css("marginRight").replace("px", ""),
              overWidth = stage.width() - el.width() - margin,
              currentPos = 0,
              left = 0,
              itemIndex = event.item.index;
            if (itemIndex > 0) {
              itemIndex -= 1;
              currentPos = event.relatedTarget._coordinates[itemIndex] * -1;
              left = (scrollbar.width() - bar.width()) / (overWidth / currentPos);
            }
            bar.animate({ left: left }, 200);
          },
        });
      }
      if (jQuery(".ajaxcart__feature-products .item .image.owl-carousel").length) {
        jQuery(".ajaxcart__feature-products .item .image.owl-carousel").owlCarousel({
          items: 1,
          margin: 0,
          loop: false,
          nav: false,
          dots: true,
          autoplay: false,
          autoplaySpeed: 1000,
          onInitialized: function (event) {
            jQuery(".product-image-wrap .owl-nav >div").click(function (e) {
              e.preventDefault();
            });
          },
        });
      }
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image;
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var preOrderNotice = false;
      if (cartItem.properties != null) {
        if (cartItem.properties.preOrder != null && cartItem.properties.preOrder != "") {
          var propertiesPreOrder = cartItem.properties.preOrder.replace("Expected", "|").replace("-", "");
          preOrderNotice = true;
        }
      }

      var product_title = cartItem.product_title.substring(0, cartItem.product_title.lastIndexOf("-") - 1);
      var product_color = cartItem.product_title.substring(cartItem.product_title.lastIndexOf("-") + 1, cartItem.product_title.length);
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: product_title,
        colour: product_color,
        variation: cartItem.variant_title,
        preOrder: propertiesPreOrder,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    // Comment for deployment
    data = {
      items: items,
      note: cart.note,
      cartCount: cart.item_count,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace("[savings]", Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
    };

    $cartContainer.append(template(data));

    cartCallback(cart);

    setTimeout(() => {
      updateDeliveryThreshold(cart);
      handleCheckoutButton();
    }, 200);
  };

  cartCallback = function (cart) {
    $body.removeClass("drawer--is-loading");
    $body.trigger("afterCartLoad.ajaxCart", cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    if (Shopify.main && typeof Shopify.main.render == "function" && $cartContainer.find("#dynamic-checkout-cart:empty")[0]) {
      Shopify.main.render($cartContainer.find("#dynamic-checkout-cart:empty")[0]);
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on("click", ".ajaxcart__qty-adjust", function () {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data("line"),
        $qtySelector = $el.siblings(".ajaxcart__qty-num"),
        qty = parseInt($qtySelector.val().replace(/\D/g, ""));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Remove Btn
    $body.on("click", ".ajaxcart__remove-adjust", function (e) {
      e.preventDefault();
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data("line"),
        qty = 0;

      if (line) {
        removeQuantity(line);
      }
    });

    // Update quantity based on input on change
    $body.on("change", ".ajaxcart__qty-num", function () {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on("focus", ".ajaxcart__qty-adjust", function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    // Remove function
    function removeQuantity(line) {
      isUpdating = true;
      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass("is-loading");
      $row.parent().addClass("is-removed");

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeRemoveItem(line, 0, adjustCartCallback);
      }, 250);
    }

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass("is-loading");

      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on("change", 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 200);
  };

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id");

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $(".js-qty__adjust").on("click", function () {
        var $el = $(this),
          id = $el.data("id"),
          $qtySelector = $el.siblings(".js-qty__num"),
          qty = parseInt($qtySelector.val().replace(/\D/g, ""));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass("js-qty__adjust--plus")) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
  };

  return module;
})(ajaxCart || {}, jQuery);
